import { MBView } from '@shared/components/MBView';
import { MBIconV2Name } from '@shared/components/image';
import { PressableTextRow } from '@shared/components/list';
import { useWorkflowTemplate } from '@shared/scenes/workflows/hooks';
import { cursorPointerStyle } from '@shared/styles';
import { API } from '@shared/types/api';

interface Props {
  component: API.SubformComponent;
}

export function DefaultSubformRow({ component }: Props) {
  const { workflowTemplate } = useWorkflowTemplate(component.default?.workflowTemplateId);

  return (
    <MBView style={cursorPointerStyle}>
      <PressableTextRow
        text={workflowTemplate?.name ?? ''}
        leftIcon={component.icon as MBIconV2Name}
        rightIcon="arrow-point-right"
        enabled={true}
      />
    </MBView>
  );
}
